import axios from "../../../../axios";

export function setLocation(payload: any) {
  const response = axios.post(`/accounts/set-location/`, payload);
  return response;
}
// export function getLocation() {
//   const response = axios.post(`/accounts/get-location/`);
//   return response;
// }
export function getLocation(id: string | null) {
  const data = id ? { anonymous_id: id } : "";
  // if (data)
  return axios.post(`/accounts/get-location/`, data);
  // else return null;
}
